import Datepicker from 'flowbite-datepicker/Datepicker';
import {Grid} from "gridjs";
import "gridjs/dist/theme/mermaid.css";
import "tabulator-tables/dist/css/tabulator_simple.min.css";
// import {Tabulator} from 'tabulator-tables';

require("fslightbox");


const datepickerEl = document.getElementById('calendar-input');

function findResults(event) {
  event.preventDefault();

  // Get the current URL
  let currentUrl = new URL(window.location.href);
  let queryParams = currentUrl.searchParams;
  if (datepickerEl) {
    queryParams.set('date', datepickerEl.value); // Replace 'param1' with the new value
  }
  queryParams.delete('page');
  queryParams.delete('search')
  queryParams.set('search', event.target.querySelector('#search').value);

  window.location.href = currentUrl.href;
}

window.findResults = findResults;


let datePicker = null;
if (datepickerEl) {
  datePicker = new Datepicker(datepickerEl, {
    autohide: true,
    orientation: 'bottom',
    format: 'dd-mm-yyyy',
    todayBtn: true,
    disableTouchKeyboard: true,
    todayHighlight: true,
    todayBtnMode: 1
    // options
  });


  document.getElementById('open-calendar').addEventListener('click', function () {
    datePicker.show();
  });

  datepickerEl.addEventListener('changeDate', function () {
    // Get the current URL
    let currentUrl = new URL(window.location.href);
    let queryParams = currentUrl.searchParams;
    queryParams.set('date', datepickerEl.value); // Replace 'param1' with the new value
    queryParams.delete('page');
    queryParams.delete('search')
    currentUrl.search = queryParams.toString();

    window.location.href = currentUrl.href;
  });
}

function openDatePicker() {
  datePicker.show();
}


// add Grid JS
let gridElements = document.getElementsByClassName('grid-js');
Array.from(gridElements).forEach(function (element) {
  console.log(element);
  let cols = element.getAttribute('data-cols');
  let colsObject = JSON.parse(cols);

  let rows = element.getAttribute('data-rows');
  let rowsObject = JSON.parse(rows);

  // let tableData = element.getAttribute('data-table');
  // let tableObject = JSON.parse(tableData);
  //
  // let table = new Tabulator(element, {
  //   data: tableObject,
  //   autoColumns: true
  //   //table setup options
  // });

  const grid = new Grid({
    columns: colsObject,
    data: rowsObject,
    sort: true,
    search: true,
    fixedHeader: true,
    className: {
      // th: 'bg-emerald-800',
      // table: 'custom-table-classname'
    }
  });

  grid.render(element);

});
